var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShoe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50.017 45.64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.0011 1.4303)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.87853 0 0 .87664 -.7045 .13162)",
    strokeDasharray: "0.569746, 0.569746",
    strokeDashoffset: 44.44,
    strokeWidth: 5.6975
  }, /*#__PURE__*/React.createElement("path", {
    d: "m45.778 47.429-11.275-.0123c-4.1486-.004526-11.975-9.208-18.159-16.401-3.6916-4.2938-10.497-10.898-11.093-16.529-.18524-1.7484-.18805-3.0664 1.084-4.2801 1.9412-1.8521 8.1275-3.7762 8.1275-3.7762-2.1951 3.3944 11.21 28.591 17.542 35.841 3.2251 3.6927 10.273 5.0702 13.774 5.1574z",
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.462 6.4306c2.8741-3.8393 7.8425-4.0787 13.756-5.3636-.65722 6.0139 6.0986 11.07 6.0986 11.07-1.5691 5.4179-2.6869 8.0487-1.4989 12.669 0 0 3.4873 12.255 9.7399 13.892 3.4708.90863 2.6916 7.6721 2.6916 7.6721",
    fill: "none",
    stopColor: "#000000"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m7.4184 31.568h-9.499",
    fill: "none",
    stopColor: "#000000",
    strokeDasharray: "0.499999, 0.499999",
    strokeDashoffset: 39,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.999 41.71h-21.798",
    fill: "none",
    stopColor: "#000000",
    strokeDasharray: "0.499999, 0.499999",
    strokeDashoffset: 39,
    strokeWidth: 5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoe);
export default __webpack_public_path__ + "static/media/shoe.7b88f27b520f50c2d070ff9bfc935702.svg";
export { ForwardRef as ReactComponent };